<template>
    <header>
        <div class="headerLeft">
            <img :src="logo" alt="logo" height="50" width="auto"/>
            <div class="logoName">{{cashierConfig.logoTitle ? cashierConfig.logoTitle : title?title:'支付平台'}}</div>
        </div>
        <div v-if="showHeaderRight" class="headerRight">
            <el-link @click="$router.push('/charge')" :type="$route.path=='/charge'?'primary':''" class="mr-15" :underline="false">
                <svg class="icon" aria-hidden="true" style="font-size:18px;">
                    <use xlink:href="#icon-charge"></use>
                </svg>
                充值
            </el-link>
            <el-link @click="$router.push('/bill')" :type="$route.path=='/bill'?'primary':''" class="ml-15 mr-15" :underline="false">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-bill"></use>
                </svg>
                账单
            </el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link @click="$router.push('/my')" :type="$route.path=='/my'?'primary':''" class="ml-15 mr-15" :underline="false">
                <i class="iconfont icon-user"></i> 个人中心
            </el-link>
            <el-link class="ml-15 mr-15" :underline="false" @click="logout"><i class="iconfont icon-logout"></i> 退出</el-link>
        </div>
    </header>
</template>

<script>
    import logo from '../assets/logo.png';
    import { mapGetters } from 'vuex';

    export default {
        name: "layout-header",
        props:['hideMenu','title',],
        computed: {
            ...mapGetters(['cashierConfig'])
        },
        watch:{
            '$route':'changeRouter'
        },
        data() {
            return {
                logo: logo,
                showHeaderRight:true,
                cashierConfigHide:false,
            }
        },
        created(){
            //this.$route.query.disable判断是否显示头部，如果三方使用我们充值页面，则带过来disable=1，则隐藏头部
            this.changeRouter();
        },
        methods:{
            changeRouter(){
                let hideFeaturePages = this.cashierConfig.hideFeaturePages;
                if(this.$route.query.disable=='1' || this.hideMenu){
                    this.showHeaderRight = false;
                }else if(hideFeaturePages){
                    let arry = hideFeaturePages.split(',');
                    for(let item of arry){
                        if(item == this.$route.path){
                            this.showHeaderRight = false;
                            break;
                        }
                    }
                }
            },
            async logout() {
                await this.$unifiedApi({api:this.$api.logout,fn:this.logout});
                this.$store.dispatch('logout').then(() => {
                    this.$router.push('/login');
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    header{
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        padding:0 28px;
        height:60px;
        min-height:60px;
        .headerLeft{
            display: flex;
            align-items: center;
            .logoName{
                padding-left:8px;
                margin-left:8px;
                border-left:1px solid #aaa;
            }
        }
        .headerRight{
            display: flex;
            align-items: center;
            .el-link{
                cursor: pointer;
            }
        }
    }
</style>